module.exports = __webpack_public_path__ + "img/9791187206590.f85aee9e.jpg";